import { render, staticRenderFns } from "./PatientOrthoPkg.vue?vue&type=template&id=3e7a93e1"
import script from "./PatientOrthoPkg.vue?vue&type=script&lang=js"
export * from "./PatientOrthoPkg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports